import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isInAppWebView } from '../utils/deviceUtil';

export default class PortalErrorPage extends Component {
  render () {
    const { device } = this.props;
    const isInApp = isInAppWebView(device);
    return (
      <div id="kakaoWrap">
        {!isInApp && (
          <div id="kakaoHead" className="head_bridge" role="banner">
            <h1 className="tit_logo">
              <a href="#none" className="link_logo"><span className="ico_plus ico_logo">카카오톡 채널</span></a>
            </h1>
          </div>
        )}
        <hr className="hide" />
        <div id="kakaoContent" className="cont_bridge" role="main">
          <div className="inner_bridge">
            <span className="img_404" />
            <strong className="tit_bridge">{this.props.title}</strong>
            <p className="desc_bridge">
              {this.props.children}
            </p>
          </div>
        </div>
      </div>
    ); 
  }
}

PortalErrorPage.propTypes = {
  device: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/containers/PortalErrorPage.js